import PaymentMethodInputs from './PaymentMethodInputs';

interface Props {
  editingPayment: any | null;
  onDoneEditing: () => void;
}

const PaymentMethodSection: React.FC<Props> = ({
  editingPayment,
  onDoneEditing,
}) => {
  return (
    <div className="w-full">
      <PaymentMethodInputs
        editingPayment={editingPayment}
        onDoneEditing={onDoneEditing}
      />
    </div>
  );
};

export default PaymentMethodSection;
